/** @jsxImportSource @emotion/react */
import { StageV2 } from 'modules/championship/domain/interfaces/stage';
import { fetchStageStatistics } from 'modules/championship/store/stages/stages.actions';
import { Table } from 'modules/championship/ui/components/form-parts/stages/stage-grid/stage-group/stage-group-table';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';
import type { DivProps } from 'typings';
import * as S from './styles';

interface IStageStandingProps extends DivProps {
  stage: StageV2;
}

function StageStanding(props: IStageStandingProps) {
  const dispatch = useDispatch<AppDispatch>();
  const { stage, ...rest } = props;

  // `stage.id` в зависимостях обязателен: экран этапа больше не размонтируется
  // при смене `:stageId` в адресе, поэтому без него осталась бы статистика
  // предыдущего этапа.
  useEffect(() => {
    dispatch(fetchStageStatistics({ stageId: stage.id }));
  }, [dispatch, stage.id]);

  return (
    <S.MainBlock {...rest}>
      <Table isEditMode={false} teams={stage.teams} statistics={stage.statistics ?? []} />
    </S.MainBlock>
  );
}

export default StageStanding;
